import { useId } from 'react';
import { LocationOn } from '@vedmarket/ui-kit';
import { COLORS } from 'config/constants';

const MarkerIcon = () => {
  const shadowId = useId().replace(/:/g, '');

  return <span className='invoice-location-marker' style={{
    display: 'block',
    width: '32px',
    height: '32px',
    filter: `url(#${shadowId})`,
  }}>
    <svg width='0' height='0' aria-hidden='true' style={{ position: 'absolute' }}>
      <defs>
        <filter id={shadowId} x='-200%' y='-200%' width='500%' height='600%' colorInterpolationFilters='sRGB'>
          <feGaussianBlur in='SourceAlpha' stdDeviation='23' result='blur1' />
          <feOffset in='blur1' dy='9' result='offset1' />
          <feFlood floodColor='black' floodOpacity='0.12' result='color1' />
          <feComposite in='color1' in2='offset1' operator='in' result='shadow1' />
          <feGaussianBlur in='SourceAlpha' stdDeviation='19' result='blur2' />
          <feOffset in='blur2' dy='24' result='offset2' />
          <feFlood floodColor='black' floodOpacity='0.14' result='color2' />
          <feComposite in='color2' in2='offset2' operator='in' result='shadow2' />
          <feGaussianBlur in='SourceAlpha' stdDeviation='7.5' result='blur3' />
          <feOffset in='blur3' dy='11' result='offset3' />
          <feFlood floodColor='black' floodOpacity='0.2' result='color3' />
          <feComposite in='color3' in2='offset3' operator='in' result='shadow3' />
          <feMerge>
            <feMergeNode in='shadow1' />
            <feMergeNode in='shadow2' />
            <feMergeNode in='shadow3' />
            <feMergeNode in='SourceGraphic' />
          </feMerge>
        </filter>
      </defs>
    </svg>
    <LocationOn width={32} height={32} aria-hidden='true' style={{
      display: 'block',
      color: COLORS.BLUE,
    }} />
  </span>;
};

export default MarkerIcon;
